import React from 'react';
import { Avatar, Box, IconButton } from '@mui/material';
import { getCaretakerAvatarUrl, getCaretakerDisplayName } from '../utils/caretakerDisplay';

interface CaretakerFaceTileProps {
  caretaker: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    avatar: string | null;
  };
  onPress: () => void;
  testId?: string;
}

/** FEAT-085 (MVP-2.25) — photo-only discovery tile; details on tap. */
const CaretakerFaceTile: React.FC<CaretakerFaceTileProps> = ({
  caretaker,
  onPress,
  testId,
}) => {
  const displayName = getCaretakerDisplayName(caretaker);
  const avatarUrl = getCaretakerAvatarUrl(caretaker);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        aspectRatio: '1',
        borderRadius: 2,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        boxShadow: 1,
      }}
    >
      <IconButton
        onClick={onPress}
        aria-label={`View profile for ${displayName}`}
        data-testid={testId ?? `caretaker-face-${caretaker.id}`}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 2,
          p: 0,
        }}
      >
        <Avatar
          src={avatarUrl}
          alt=""
          aria-hidden
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: 2,
          }}
        />
      </IconButton>
    </Box>
  );
};

export default CaretakerFaceTile;
